import JSONAPIAdapter from '@ember-data/adapter/json-api';
import { service } from '@ember/service';

import config from 'garaje/config/environment';
import rewriteProxyRelationshipLink from 'garaje/utils/proxy-relationship-link';

export default class extends JSONAPIAdapter {
  namespace = 'a/visitors/api/v2';
  host = config.apiOverwrittenHost;
  useFetch = false;

  @service cookieAuth;
  @service metrics;
  @service session;

  handleResponse(status, _headers, _payload, _requestData) {
    if (status === 401 && this.session.isAuthenticated) {
      this.session.invalidate();
    }
    return super.handleResponse(...arguments);
  }

  shouldReloadAll() {
    return true;
  }

  shouldBackgroundReloadRecord() {
    return false;
  }

  ajaxOptions(url, type, options = {}) {
    let hash = super.ajaxOptions(url, type, options);
    hash = this.cookieAuth.decorate(type, hash);

    hash.headers['X-Forwarded-Host'] = config.hostName;
    hash.headers['X-Envoy-Context'] = JSON.stringify(this.metrics.getEnvoyContext());

    return hash;
  }

  ajax(url, method, hash = {}) {
    hash.xhrFields = { withCredentials: true };

    // V2Adapter is the parent adapter for invite/entry; ember-data follows their
    // async hasMany links (e.g. platformJobs) through THIS adapter, and those links
    // come back as absolute api/v3 URLs. In proxyMode this rewrites the staging host
    // to the local proxy and adds the a/visitors prefix so the follow is reachable.
    url = rewriteProxyRelationshipLink(url);

    if (!url.includes('a/visitors/api/v2')) {
      url = url.replace('api/v2', 'a/visitors/api/v2');
    }
    return super.ajax(url, method, hash);
  }
}
